import getIframeDocument from '@newswebsiteapp/shared/lib/getIframeDocument'

export default function resizeIframeToFitContent(iframe) {
  const iframeDocument = getIframeDocument(iframe)

  iframe.style.height = `${iframeDocument.body.scrollHeight}px` // eslint-disable-line no-param-reassign
}
